import * as React from 'react';
import * as classNames from 'classnames';
import {SFC} from 'react';
import './styles.sass';

interface IJobsPosition {
  expanded: boolean;
  name: string;
  city: string;
}
export const JobsPosition: SFC<IJobsPosition> = ({
  expanded,
  name,
  city,
}) => (
  <div className={'jobs-position'}>
    <span className={'jobs-position__name'}>{name}</span>
    <span className={'jobs-position__city'}>{city}</span>
    <i className={classNames('jobs-position__icon', {'jobs-position__icon_expanded': expanded})} />
  </div>
);
